<template>
  <div class="ushk-rili_filter">
    <jin-popover
      placement="bottom-end"
      popper-class="ushk-rili_filter-popover"
      ref="filter"
      transition="zoom-in-bottom"
      v-model="visible">
      <div class="ushk-rili_filter-box">
        <div class="ushk-rili_filter-item">
            <h3 class="ushk-rili_filter-title">状 态</h3>
            <div class="ushk-rili_filter-list">
                <a v-for="(state, index) in states" :key="index" :href="state.href ? state.href : 'javascript:;'" class="ushk-rili_filter-btn" :class="{'active': state.name === curName}" @click="change(state.type, state.name)">{{ state.name }}</a>
            </div>
        </div>
        <div class="ushk-rili_filter-item">
            <h3 class="ushk-rili_filter-title">按照国家/地区条件查询</h3>
            <div v-for="(item, index) in countrys" :key="index" class="l-cell">
                <div class="l-cell_item ushk-rili_filter-l">
                    <h4>{{ item.region }}</h4>
                </div>
                <div class="l-cell_item ushk-rili_filter-r">
                    <div class="ushk-rili_filter-list">
                        <a v-for="(name, nameIndex) in item.datas" :key="nameIndex" href="javascript:;" class="ushk-rili_filter-btn" :class="{'active': name === curName}" @click="change(item.type, name)">{{ name }}</a>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </jin-popover>
    <a v-popover:filter href="javascript:;" :class="{'is-active': visible}">
      <span>{{ curName }}</span>
      <i class="ushk-icon ushk-icon_triangle"></i>
    </a>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        visible: false,
        curName: '全部',
        states: [
          {
            type: 'all',
            name: '全部'
          },
          {
            href: 'https://www.ushknews.com/calendar.html',
            name: '今日'
          },
          {
            type: 'actual',
            name: '未公布'
          },
          {
            type: 'important',
            name: '重要'
          }
        ],
        countrys: [
          {
            region: '地 区',
            type: 'all',
            datas: [
              '全部'
            ]
          },
          {
            region: '欧 洲',
            type: 'country',
            datas: [
              '欧元区',
              '德 国',
              '英 国',
              '法 国',
              '瑞 士',
              '意大利',
              '西班牙'
            ]
          },
          {
            region: '北 美',
            type: 'country',
            datas: [
              '美 国',
              '加拿大'
            ]
          },
          {
            region: '亚 洲',
            type: 'country',
            datas: [
              '中 国',
              '日 本',
              '韩 国',
              '印 度',
              '香 港',
              '台 湾',
              '新加坡'
            ]
          },
          {
            region: '澳 洲',
            type: 'country',
            datas: [
              '澳大利亚',
              '新西兰'
            ]
          }
        ]
      }
    },
    methods: {
      change (type, name) {
        this.curName = name
        this.$emit('change', {
          type,
          name
        })
        this.visible = false
      }
    }
  }
  </script>



// WEBPACK FOOTER //
// ListFilter.vue?0699a3b3